import { get } from "app/utils/axios/kheti";
import { FetchPastDiagnosisResponse } from "../models/diagnosis";

const fetchPastDiagnosis = async (limit?: number) => {
  try {
    const queryParam = limit ? `?limit=${limit}` : "";
    const response = await get<FetchPastDiagnosisResponse>(
      `plantix/v1/history/summary${queryParam}`
    );
    return response;
  } catch (e) {
    return null;
  }
};

export default fetchPastDiagnosis;
